<template>
  <Tabs class="manage-section" v-model="selectedTab">
    <FeatureSection title="A Blazing Fast Bio Link Made Your Way">
      <VText slot="text"
        >Create with ease, customize with ease, and share with ease. Get a high
        conversion, mobile-optimized landing page setup in minutes.</VText
      >

      <div class="manage-section__tabs-wrapper" slot="cta">
        <TabBar class="manage-section__tab-bar" aria-label="Section">
          <Tab value="organize">Organize</Tab>
          <Tab value="personalize">Personalize</Tab>
          <Tab value="engage">Engage</Tab>
          <Tab value="auto-pilot">Auto-Pilot</Tab>
          <Tab value="monetize">Convert &amp; Monetize</Tab>
          <Tab value="insights">Insights</Tab>
        </TabBar>
      </div>

      <OrganizeSection class="span-2" />
      <EngageSection class="span-2" />
      <AutoPilotSection class="span-2" />
      <MonetizeSection class="span-2" />
      <PersonalizeSection class="span-2" />
      <InsightsSection class="span-2" />
    </FeatureSection>
  </Tabs>
</template>

<script>
import { VText, Tabs, Tab, TabBar } from '@campsite-bio/component-lib';
import { ref } from '@nuxtjs/composition-api';

import FeatureSection from '@/components/features/feature-section';
import OrganizeSection from './sections/organize-section';
import EngageSection from './sections/engage-section';
import AutoPilotSection from './sections/auto-pilot-section';
import MonetizeSection from './sections/monetize-section';
import PersonalizeSection from './sections/personalize-section';
import InsightsSection from './sections/insights-section';

export default {
  components: {
    VText,
    Tabs,
    Tab,
    TabBar,
    FeatureSection,
    OrganizeSection,
    EngageSection,
    AutoPilotSection,
    MonetizeSection,
    PersonalizeSection,
    InsightsSection,
  },

  setup() {
    const selectedTab = ref('organize');

    return { selectedTab };
  },
};
</script>

<style lang="scss" scoped>
.span-2 {
  @media (min-width: 768px) {
    grid-column: span 2;
  }
}

.manage-section {
  &__tabs-wrapper {
    white-space: nowrap;

    @media (max-width: 767px) {
      overflow-x: scroll;
      padding-bottom: 0.25rem;
      margin-left: -0.9375rem;
      margin-right: -0.9375rem;
      padding-left: 0.9375rem;
      padding-right: 0.9375rem;
    }
  }

  &__tab-bar {
    @media (min-width: 768px) {
      justify-content: center;
    }
  }
}
</style>
